import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router";
import { getApi, putApi } from "../../services/api/globalApi";
import { convertDate } from "../../utils/convertDate";
import { digitsThree } from "../../utils/price";
import { Link } from "react-router-dom";
import { utilsState } from "../../sotre/redux/features/utilsSlice";
import { useSelector } from "react-redux";
import { successMessage } from "../../utils/toastify-message/ToastifyMessage";
import SingleOrderCard from "./sub-components/single-order/SingleOrderCard";
import EditOrderModal from "./sub-components/edit-order-modal/EditOrderModal";
import RejectOrderModal from "./sub-components/reject-order-modal/RejectOrderModal";

function ShowSingleOrder() {
  const { utils } = useSelector(utilsState);

  const [data, setData] = useState(null);
  const location = useLocation();
  const path = `admin/users/${location?.pathname.slice(7)}`;

  console.log(location?.pathname.slice(12));

  const getSingleOrder = async () => {
    const path = `${"admin/orders/"}${location?.pathname.slice(12)}`;
    try {
      const data = await getApi({ path });
      console.log(data);
      setData(data.data.result);
      setProccessShipping(data.data.result.proccessShipping);
    } catch (error) {}
  };

  useEffect(() => {
    getSingleOrder();
  }, []);

  const editRef = useRef();

  const [proccessShipping, setProccessShipping] = useState("");

  const changeProccess = async () => {
    const path = `admin/orders/${data?._id}/proccessShipping`;
    const body = {
      proccessShipping,
    };
    try {
      await putApi({ path, body });
      successMessage("وضعیت سفارش با موفقیت تغییر داده شد");
    } catch (error) {
      console.log(error);
    }
  };

  const rejectRef = useRef();

  return (
    <>
      <EditOrderModal
        ref={editRef}
        productData={data}
        reGetData={getSingleOrder}
      />
      <RejectOrderModal ref={rejectRef} orderData={data} />

      <div className="w-full max-w-7xl px-4 md:px-5 lg-6 mx-auto py-4">
        <div className="main-box bg-white rounded-3xl  border border-gray-200 rounded-xl max-w-xl max-lg:mx-auto lg:max-w-full">
          <div className="flex w-full my-3 px-3 items-center justify-between">
            <h3 className="font-bold text-lg">مشخصات سفارش :</h3>
            <div className="flex items-center gap-2">
              {data?.paymentStatus === "done" &&
              data?.proccessShipping === "awaitingAccepted" ? (
                <button
                  onClick={() => rejectRef.current.showModal()}
                  type="button"
                  className="text-white bg-red-700 hover:bg-red-800 focus:ring-4 focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-red-600 dark:hover:bg-red-700 focus:outline-none dark:focus:ring-red-800"
                >
                  لغو
                </button>
              ) : null}
              <button
                onClick={() => editRef.current.showModal()}
                type="button"
                className="text-white bg-green-700 hover:bg-green-800 focus:ring-4 focus:ring-green-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-green-600 dark:hover:bg-green-700 focus:outline-none dark:focus:ring-green-800"
              >
                ویرایش
              </button>
              <Link to={"/order-list"}>
                <button
                  type="button"
                  className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
                >
                  لیست سفارشات
                </button>
              </Link>
            </div>
          </div>

          <div className="flex items-center gap-2 pb-6 border-b border-gray-400 px-6 ">
            <p>وضعیت :</p>
            <div>
              <select
                value={proccessShipping}
                onChange={(e) => setProccessShipping(e.target.value)}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              >
                {utils?.ORDER_PROCCESS_SHIPPING_STATUS_VALUES?.map((item) => {
                  return (
                    <option key={item.value} value={item?.value}>
                      {item?.name}
                    </option>
                  );
                })}
              </select>
            </div>
            <button
              onClick={() => changeProccess()}
              type="button"
              className="text-white bg-green-700 hover:bg-green-800 focus:ring-4 focus:ring-green-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 dark:bg-green-600 dark:hover:bg-green-700 focus:outline-none dark:focus:ring-green-800"
            >
              تغییر وضعیت
            </button>
          </div>

          <h3 className="my-3 px-3 font-bold text-lg">مشخصات کاربر :</h3>
          <div className="flex flex-col gap-6 pb-6 border-b border-gray-400 px-6 ">
            <div className="flex flex-col lg:flex-row lg:items-center justify-between">
              <div className="data w-full">
                <p className="font-semibold text-base leading-7 text-black">
                  نام:{" "}
                  <span className="text-indigo-600 font-medium">
                    {" "}
                    {data?.user.name}
                  </span>
                </p>
                <p className="font-semibold text-base leading-7 text-black mt-4">
                  موبایل :{" "}
                  <span className="text-gray-400 font-medium">
                    {" "}
                    {data?.user.mobile}
                  </span>
                </p>
              </div>
              <div className="data w-full">
                <p className="font-semibold text-base leading-7 text-black">
                  شماره سفارش:{" "}
                  <span className="text-indigo-600 font-medium">
                    #{data?.trackingCode}
                  </span>
                </p>
                <p className="font-semibold text-base leading-7 text-black mt-4">
                  تاریخ :{" "}
                  <span className="text-gray-400 font-medium">
                    {" "}
                    {convertDate(data?.createdAt)}
                  </span>
                </p>
              </div>
            </div>
            <div className="flex flex-col lg:flex-row lg:items-center justify-between">
              <div className="data w-full">
                <p className="font-semibold text-base leading-7 text-black">
                  مبلغ کل:{" "}
                  <span className="text-indigo-600 font-medium">
                    {digitsThree(data?.totalPrice)} تومان
                  </span>
                </p>
                <p className="font-semibold text-base leading-7 text-black mt-4">
                  مبلغ پرداخت شده:{" "}
                  <span className="text-gray-400 font-medium">
                    {" "}
                    {digitsThree(data?.finalPrice)} تومان
                  </span>
                </p>
              </div>
              <div className="data w-full">
                <p className="font-semibold text-base leading-7 text-black">
                  تخفیف:{" "}
                  <span className="text-indigo-600 font-medium">
                    {digitsThree(data?.totalDiscount)} تومان
                  </span>
                </p>
                <p className="font-semibold text-base leading-7 text-black mt-4">
                  هزینه حمل و نقل:{" "}
                  <span className="text-gray-400 font-medium">
                    {" "}
                    {digitsThree(data?.shippingFinalPrice)} تومان
                  </span>
                </p>
              </div>
            </div>
          </div>

          <h3 className="my-3 px-3 font-bold text-lg">مشخصات تحویل گیرنده :</h3>
          <div className="flex flex-col gap-6 pb-6 border-b border-gray-400 px-6 ">
            <div className="flex flex-col lg:flex-row lg:items-center justify-between">
              <div className="data w-full">
                <p className="font-semibold text-base leading-7 text-black">
                  نام :{" "}
                  <span className="text-indigo-600 font-medium">
                    {data?.name || "-"}{" "}
                  </span>
                </p>
              </div>
              <div className="data w-full">
                <p className="font-semibold text-base leading-7 text-black">
                  موبایل :{" "}
                  <span className="text-indigo-600 font-medium">
                    {data?.mobile || "-"}{" "}
                  </span>
                </p>
              </div>
            </div>
            <div className="flex flex-col lg:flex-row lg:items-center justify-between">
              <div className="data w-full">
                <p className="font-semibold text-base leading-7 text-black">
                  آدرس :{" "}
                  <span className="text-indigo-600 font-medium">
                    {data?.address || "-"}{" "}
                  </span>
                </p>
              </div>
              <div className="data w-full">
                <p className="font-semibold text-base leading-7 text-black">
                  استان:{" "}
                  <span className="text-indigo-600 font-medium">
                    {data?.province}
                  </span>
                </p>
              </div>
            </div>
            <div className="flex flex-col lg:flex-row lg:items-center justify-between">
              <div className="data w-full">
                <p className="font-semibold text-base leading-7 text-black">
                  شهر :{" "}
                  <span className="text-indigo-600 font-medium">
                    {data?.city}
                  </span>
                </p>
              </div>
              <div className="data w-full">
                <p className="font-semibold text-base leading-7 text-black">
                  کد پستی:{" "}
                  <span className="text-indigo-600 font-medium">
                    {data?.postcode || "-"}
                  </span>
                </p>
              </div>
            </div>
            <div className="data w-full">
              <p className="font-semibold text-base leading-7 text-black">
                توضیحات:{" "}
                <span className="text-indigo-600 font-medium">
                  {data?.description || "-"}
                </span>
              </p>
            </div>
            <div className="data w-full">
              <p className="font-semibold text-base leading-7 text-black">
                بارکد:{" "}
                <span className="text-indigo-600 font-medium">
                  {data?.barcode || "-"}
                </span>
              </p>
            </div>
          </div>

          <h3 className="my-3 px-3 font-bold text-lg">شرح کالا :</h3>
          <div className="w-full px-3 min-[400px]:px-6">
            {data?.products.length > 0 &&
              data?.products.map((item, index) => {
                return <SingleOrderCard key={index} data={item} />;
              })}
          </div>
        </div>
      </div>
    </>
  );
}

export default ShowSingleOrder;
